module.exports = __webpack_public_path__ + "img/18.0f0224d.png";